<ng-container *ngIf="viewMode() === 'query'">

  <!-- Page Header -->
  <div class="bg-gray-50 mb-6 px-3">
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12">
        <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
          <div class="border-l-4 border-gray-800 pl-4">
            <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
              Reports Section
            </p>
            <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
              Builder
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Layout -->
  <div class="grid min-h-screen grid-cols-12 gap-6 bg-gray-50 mb-6 px-3">

    <!-- Main Content -->
    <div class="col-span-12 lg:col-span-9" [ngClass]="{ 'mt-[1.4rem]': !showDropdowns() }">
      <div class="grid grid-cols-12 gap-5">

        <!-- Filters -->
        <ng-container *ngIf="showDropdowns()">

          <!-- Filters Card -->
          <div class="col-span-12 rounded-2xl border border-gray-300 bg-white p-5">

            <div class="mb-5 flex min-h-[60px] flex-col gap-4 border-b border-gray-300 pb-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Filters
                </p>
                <h3 class="mt-1 text-lg font-bold text-gray-800">
                  Report options
                </h3>
              </div>

              <div class="inline-flex overflow-hidden rounded-xl border border-gray-300 bg-gray-100 p-1">
                <button
                  type="button"
                  class="cursor-pointer rounded-lg px-5 py-2.5 text-sm font-semibold transition"
                  [ngClass]="viewMode() === 'query'
                    ? 'bg-slate-700 text-white'
                    : 'text-gray-700 hover:bg-white hover:text-gray-900'"
                  (click)="setView('query')">
                  Report Builder
                </button>

                <button
                  type="button"
                  class="cursor-pointer rounded-lg px-5 py-2.5 text-sm font-semibold transition"
                  [ngClass]="viewMode() === 'metrics'
                    ? 'bg-slate-700 text-white'
                    : 'text-gray-700 hover:bg-white hover:text-gray-900'"
                  (click)="setView('metrics')">
                  Page Metrics
                </button>
              </div>
            </div>

            <div class="grid grid-cols-12 gap-4">

              <!-- Website -->
              <div class="col-span-12 sm:col-span-6 xl:col-span-3">
                <label class="mb-2 block text-sm font-semibold text-gray-700">
                  Website
                </label>
                <select
                  class="w-full cursor-pointer rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                  [ngModel]="selectedSiteId()"
                  (ngModelChange)="onSiteChange($event)">
                  <option [ngValue]="null" disabled>Select a site</option>
                  <option *ngFor="let site of sites()" [ngValue]="site.ID">
                    {{ site?.Domain }}
                  </option>
                </select>
              </div>

              <!-- Platform -->
              <div class="col-span-12 sm:col-span-6 xl:col-span-3">
                <label class="mb-2 block text-sm font-semibold text-gray-700">
                  Platform
                </label>
                <select
                  class="w-full cursor-pointer rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                  [ngModel]="selectedPlatformId()"
                  (ngModelChange)="onPlatformChange($event)">
                  <option [ngValue]="null">All</option>
                  <option *ngFor="let platform of filteredPlatforms()" [ngValue]="platform.id">
                    {{ platform?.platform }}
                  </option>
                </select>
              </div>

              <!-- Date Range -->
              <div class="col-span-12 sm:col-span-6 xl:col-span-3">
                <label class="mb-2 block text-sm font-semibold text-gray-700">
                  Date range
                </label>
                <select
                  class="w-full cursor-pointer rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                  [ngModel]="selectedPeriod()"
                  (ngModelChange)="onPeriodChange($event)">
                  <option [ngValue]="'days_28'">Last 30d</option>
                  <option [ngValue]="'week'">Last 7d</option>
                </select>
              </div>

              <!-- Format -->
              <div class="col-span-12 sm:col-span-6 xl:col-span-3">
                <label class="mb-2 block text-sm font-semibold text-gray-700">
                  Format
                </label>
                <select
                  class="w-full cursor-pointer rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                  [ngModel]="selectedFormat()"
                  (ngModelChange)="selectedFormat.set($event); pageIndex.set(0); applySearch()">
                  <option [ngValue]="null">All</option>
                  <option *ngFor="let f of formatOptions()" [ngValue]="f">
                    {{ formatLabel(f) }}
                  </option>
                </select>
              </div>

              <!-- Custom Dates -->
              <div class="col-span-12" *ngIf="selectedPeriod() === 'custom'">
                <div class="grid grid-cols-12 gap-4 rounded-xl border border-gray-300 bg-gray-50 p-4">
                  <div class="col-span-12 sm:col-span-6 lg:col-span-3">
                    <label class="mb-2 block text-sm font-semibold text-gray-700">
                      From
                    </label>
                    <input
                      type="date"
                      class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-700 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                      [ngModel]="customFrom()"
                      (ngModelChange)="onCustomFromChange($event)" />
                  </div>

                  <div class="col-span-12 sm:col-span-6 lg:col-span-3">
                    <label class="mb-2 block text-sm font-semibold text-gray-700">
                      To
                    </label>
                    <input
                      type="date"
                      class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-700 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                      [ngModel]="customTo()"
                      (ngModelChange)="onCustomToChange($event)" />
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Performance Filters -->
          <div class="col-span-12" *ngIf="metricOptions().length">
            <div class="rounded-2xl border border-gray-300 bg-white p-5">

              <div class="mb-5 flex flex-col gap-4 border-b border-gray-300 pb-4 xl:flex-row xl:items-center xl:justify-between">
                <div>
                  <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Performance filters
                  </p>
                  <h3 class="mt-1 text-lg font-bold text-gray-800">
                    Metrics rules
                  </h3>
                </div>

                <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
                  <span class="text-sm font-semibold text-gray-600">
                    Logic:
                  </span>

                  <div class="inline-flex w-fit overflow-hidden rounded-xl border border-gray-300 bg-white">
                    <button
                      type="button"
                      class="px-5 py-2 text-sm font-semibold transition"
                      [ngClass]="metricLogic() === 'and'
                        ? 'bg-gray-800 text-white'
                        : 'bg-white text-gray-600 hover:bg-gray-50'"
                      (click)="setMetricLogic('and')"
                      matTooltip="Applies ALL metric filters at the same time. (e.g., Likes ≥ 50 AND Clicks ≥ 10)"
                      matTooltipPosition="above"
                      matTooltipShowDelay="250">
                      Match all (AND)
                    </button>

                    <div class="w-px bg-gray-300"></div>

                    <button
                      type="button"
                      class="px-5 py-2 text-sm font-semibold transition"
                      [ngClass]="metricLogic() === 'or'
                        ? 'bg-gray-800 text-white'
                        : 'bg-white text-gray-600 hover:bg-gray-50'"
                      (click)="setMetricLogic('or')"
                      matTooltip="Applies ANY of the metric filters. (e.g., Likes ≥ 50 OR Clicks ≥ 10)"
                      matTooltipPosition="above"
                      matTooltipShowDelay="250">
                      Match any (OR)
                    </button>
                  </div>
                </div>
              </div>

              <!-- Metric Chips -->
              <div class="mb-5 flex flex-wrap gap-2">
                <button
                  type="button"
                  *ngFor="let m of metricOptions()"
                  (click)="selectMetric(m.key)"
                  class="rounded-full border px-4 py-2 text-xs font-semibold transition"
                  [ngClass]="selectedMetricKey() === m.key
                    ? 'border-gray-800 bg-gray-800 text-white'
                    : 'border-gray-300 bg-white text-gray-600 hover:border-gray-500 hover:text-gray-900'">
                  {{ m.label }}
                </button>
              </div>

              <!-- Min / Max / Actions -->
              <div class="grid grid-cols-12 gap-3">
                <div class="col-span-12 sm:col-span-6 xl:col-span-4">
                  <label class="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Min
                  </label>
                  <div class="relative">
                    <input
                      [step]="selectedMetricKey() === 'er' ? '0.01' : '1'"
                      class="w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 pr-8 text-sm text-gray-700 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                      [ngModel]="metricMin()"
                      (ngModelChange)="metricMin.set($event === '' ? null : +$event)"
                      [placeholder]="metricPlaceholderMin()" />

                    <span
                      *ngIf="selectedMetricKey() === 'er'"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">
                      %
                    </span>
                  </div>
                </div>

                <div class="col-span-12 sm:col-span-6 xl:col-span-4">
                  <label class="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Max
                  </label>
                  <div class="relative">
                    <input
                      [step]="selectedMetricKey() === 'er' ? '0.01' : '1'"
                      class="w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 pr-8 text-sm text-gray-700 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                      [ngModel]="metricMax()"
                      (ngModelChange)="metricMax.set($event === '' ? null : +$event)"
                      [placeholder]="metricPlaceholderMax()" />

                    <span
                      *ngIf="selectedMetricKey() === 'er'"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">
                      %
                    </span>
                  </div>
                </div>

                <div class="col-span-12 flex flex-col gap-2 sm:flex-row xl:col-span-4 xl:items-end">
                  <button
                    type="button"
                    class="flex-1 rounded-xl border border-gray-800 bg-gray-800 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-gray-900 disabled:cursor-not-allowed disabled:opacity-60"
                    (click)="applyMetricFilter()"
                    [disabled]="!selectedMetricKey() || (metricMin() == null && metricMax() == null)">
                    Apply
                  </button>

                  <button
                    type="button"
                    class="flex-1 rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
                    (click)="clearMetricFilter()"
                    [disabled]="!hasMetricFilter()">
                    Clear
                  </button>
                </div>
              </div>

            </div>
          </div>

        </ng-container>

        <!-- Results Card -->
        <div class="col-span-12 overflow-hidden rounded-2xl border border-gray-300 bg-white">

          <!-- Results Header -->
          <div class="flex flex-col gap-4 border-b border-gray-300 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h3 class="text-lg font-bold text-gray-800">
                Results
              </h3>
              <p class="mt-0.5 text-xs font-medium text-gray-400">
                {{ totalItems() }} results
              </p>
            </div>

            <!-- Search -->
            <div class="flex h-10 w-full items-center rounded-xl border border-gray-300 bg-gray-50 px-3 transition focus-within:border-gray-400 focus-within:ring-2 focus-within:ring-gray-200 sm:max-w-[280px]">
              <mat-icon class="flex-shrink-0 text-[18px] text-gray-400">
                search
              </mat-icon>

              <input
                type="text"
                placeholder="Search..."
                [ngModel]="textQuery()"
                (ngModelChange)="textQuery.set($event)"
                (keyup.enter)="applySearch()"
                class="min-w-0 flex-grow bg-transparent px-2 text-sm text-gray-700 outline-none placeholder-gray-400" />

              <button
                type="button"
                (click)="clearSearch()"
                [class.opacity-0]="!textQuery()"
                [class.pointer-events-none]="!textQuery()"
                class="ml-1 flex flex-shrink-0 items-center justify-center text-gray-400 transition hover:text-gray-700">
                <mat-icon class="cursor-pointer text-sm">
                  close
                </mat-icon>
              </button>
            </div>
          </div>

          <!-- Active Filter Chips -->
          <div class="flex flex-wrap items-center gap-2 border-b border-gray-300 bg-gray-50 px-5 py-3">
            <span class="mr-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
              Active filters:
            </span>

            <ng-container *ngFor="let chip of activeChips()">
              <span class="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-gray-300 bg-white px-3 py-1 text-xs font-medium text-gray-700">
                {{ chip.label }}

                <button
                  *ngIf="canRemoveChip(chip)"
                  type="button"
                  class="inline-flex h-4 w-4 items-center justify-center rounded-full text-gray-400 transition hover:bg-gray-100 hover:text-gray-700"
                  (click)="removeChip(chip)"
                  aria-label="Remove filter">
                  &#x2715;
                </button>
              </span>
            </ng-container>

            <span *ngIf="activeChips().length === 0" class="text-xs text-gray-400">
              None
            </span>
          </div>

          <!-- Top Paginator -->
          <div class="flex items-center justify-end border-b border-gray-300 px-5 py-1.5">
            <mat-paginator
              [length]="totalItems()"
              [pageSize]="pageSize()"
              [pageSizeOptions]="[pageSize()]"
              showFirstLastButtons
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>

          <!-- Table -->
          <div class="overflow-auto">
            <table class="w-full min-w-[950px] text-sm">
              <thead class="border-b border-gray-300 bg-gray-50">
                <tr class="text-left">
                  <th
                    *ngFor="let c of columns()"
                    class="select-none whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500"
                    [class.hidden]="!visibleColumns().has(c.key)"
                    [class.cursor-pointer]="isSortableColumn(c.key)"
                    (click)="isSortableColumn(c.key) ? toggleSort(c.key) : null"
                    [matTooltip]="c.tooltip || ''"
                    matTooltipPosition="above"
                    matTooltipShowDelay="250">
                    <span class="inline-flex items-center gap-1">
                      {{ c.label }}

                      <span
                        *ngIf="isSortableColumn(c.key)"
                        class="text-[10px]"
                        [ngClass]="activeSort().field === c.key ? 'text-gray-700' : 'text-gray-300'">
                        <ng-container *ngIf="activeSort().field === c.key; else bothArrows">
                          {{ activeSort().dir === 'asc' ? '▲' : '▼' }}
                        </ng-container>
                        <ng-template #bothArrows>▲▼</ng-template>
                      </span>
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody class="divide-y divide-gray-300">
                <tr
                  *ngFor="let r of pagedRows()"
                  class="transition hover:bg-gray-50">
                  <td
                    *ngFor="let c of columns()"
                    class="whitespace-nowrap px-4 py-3 text-gray-700"
                    [class.hidden]="!visibleColumns().has(c.key)">
                    <ng-container [ngSwitch]="c.key">

                      <ng-container *ngSwitchCase="'title'">
                        <span
                          class="cursor-pointer font-semibold text-gray-900 transition hover:text-gray-700 hover:underline"
                          [matTooltip]="r.title"
                          matTooltipPosition="above"
                          (click)="goToPreview(r)">
                          {{ title3Words(r.title) }}
                        </span>
                      </ng-container>

                      <ng-container *ngSwitchCase="'format'">
                        {{ formatLabel(r.format) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'reach'">
                        {{ fmtNumber(r.reach) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'impressions'">
                        {{ fmtNumber(r.impressions) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'likes'">
                        {{ fmtNumber(r.likes) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'comments'">
                        {{ fmtNumber(r.comments) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'shares'">
                        {{ fmtNumber(r.shares) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'clicks'">
                        {{ fmtNumber(r.clicks) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'er'">
                        {{ fmtPct(r.er) }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'badges'">
                        <div class="flex flex-wrap gap-2">
                          <ng-container *ngIf="r.badges.length; else noBadge">
                            <span
                              *ngFor="let b of r.badges"
                              class="rounded-full border px-2 py-1 text-xs font-semibold"
                              [ngClass]="b === 'Low ER'
                                ? 'border-red-200 bg-red-50 text-red-700'
                                : 'border-gray-300 bg-gray-50 text-gray-700'">
                              {{ b }}
                            </span>
                          </ng-container>

                          <ng-template #noBadge>
                            <span class="text-gray-400">—</span>
                          </ng-template>
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchDefault>
                        {{ cellValue(r, c.key) }}
                      </ng-container>

                    </ng-container>
                  </td>
                </tr>

                <tr *ngIf="sortedRows().length === 0">
                  <td class="p-10 text-center text-gray-500" [attr.colspan]="visibleColumns().size">
                    <div class="flex flex-col items-center justify-center gap-2">
                      <mat-icon class="text-gray-400">inbox</mat-icon>
                      <p class="text-sm font-semibold text-gray-700">
                        No results
                      </p>
                      <p class="text-xs text-gray-400">
                        Adjust filters or search query.
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer -->
          <div class="flex flex-col gap-3 border-t border-gray-300 bg-gray-50 px-5 py-3 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex flex-wrap items-center gap-2">
              <span class="rounded-full border border-gray-300 bg-white px-3 py-1 text-xs font-semibold text-gray-500">
                Latest update: {{ syncedAtUtc() || '—' }}
              </span>

              <span class="rounded-full border border-gray-300 bg-white px-3 py-1 text-xs font-semibold text-gray-500">
                Timezone: Europe/Athens
              </span>
            </div>

            <mat-paginator
              [length]="totalItems()"
              [pageSize]="pageSize()"
              [pageSizeOptions]="[pageSize()]"
              showFirstLastButtons
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>

        </div>

      </div>
    </div>

    <!-- Sidebar Tools -->
    <div class="col-span-12 lg:col-span-3">
      <div class="sticky top-[120px] rounded-2xl border border-gray-300 bg-white p-5">

        <div class="mb-5 border-b border-gray-300 pb-4">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Tools
          </p>
          <h3 class="mt-1 text-lg font-bold text-gray-800">
            View settings
          </h3>
        </div>

        <!-- Column Picker -->
        <div>
          <p class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
            Column Picker
          </p>

          <div class="flex flex-col gap-2">
            <label
              class="flex cursor-pointer items-center gap-2 rounded-lg border border-transparent px-2 py-1.5 text-sm transition hover:border-gray-300 hover:bg-gray-50"
              *ngFor="let c of columns()">
              <input
                type="checkbox"
                [checked]="visibleColumns().has(c.key)"
                (change)="toggleColumn(c.key)" />

              <span class="text-gray-700">
                {{ c.label }}
              </span>
            </label>
          </div>
        </div>

        <!-- Bulk Actions -->
        <div class="mt-6">
          <div class="grid grid-cols-2 gap-2">
            <button
              class="cursor-pointer rounded-xl border border-gray-800 bg-gray-800 px-3 py-2.5 text-xs font-semibold text-white transition hover:bg-gray-900"
              (click)="bulkExportPdf()"
              type="button">
              Export PDF
            </button>

            <button
              class="cursor-pointer rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-xs font-semibold text-gray-700 transition hover:bg-gray-50"
              (click)="bulkExportExcel()"
              type="button">
              Export Excel
            </button>
          </div>

          <button
            class="mt-3 w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-xs font-semibold text-gray-700 transition hover:bg-gray-50"
            (click)="openSavedView()"
            type="button">
            Save View
          </button>
        </div>

      </div>
    </div>

  </div>
</ng-container>